<template>
  <div>
    <div class="register-container">
      <div v-if="isSuccess">
        <div class="text-center">
          <h1>サービス登録完了</h1>
        </div>
        <div class="announce-container">
          <span>サービス登録が完了しました。</span>
          <br>
          <br>
          <span>ログイン情報は、メールにお送りしました。</span>
          <br>
          <span>以下よりログインしてください。</span>
          <br>
          <br>
          <button type="button" class="btn btn-info btn-block" @click.prevent="toLogin">ログイン</button>
        </div>
      </div>
      <div v-else-if="isExpired || error">
        <div class="text-center">
          <h1>このURLは利用出来ません </h1>
        </div>
        <div class="announce-container">
          <h3 class="text-red">メール本文に記載されたURLと異なるURLを指定している <br>
          （メールソフトによりURLが改行されている等）か、<br>
            URLの有効期限が切れている可能性があります。
          </h3>
          <br>
          <span>
            有効期限切れの場合は以下より<br>
            再度登録を行ってください。
          </span>
          <br>
          <br>
          <button type="button" class="btn btn-info btn-block" @click.prevent="toSignup">新規登録</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AuthenticationService from '@/services/authenticationservice'
import ChatworkService from '@/services/chatworkservice'
import PageNotFound from '@/components/PageNotFound'
import * as code from '@/common/code'

export default {
  components: {
    PageNotFound
  },
  data () {
    return {
      isExpired: false,
      error: null,
      isSuccess: false
    }
  },
  created () {
    this.doActive()
  },
  methods: {
    async doActive () {
      let token = this.$route.query.token
      if (token && token !== '') {
        const loader = this.$loading.show()
        await AuthenticationService.active(token)
          .then(response => {
            if (response.resultCode === code.urlExpired) {
              this.isExpired = true
            } else {
              this.isSuccess = true
              this.createGroupChatwork(response.data.seller_id)
            }
          })
          .catch(err => {
            this.error = err
          })
          .finally(() => {
            loader.hide()
          })
      } else {
        this.$router.push('/not-found')
      }
    },
    createGroupChatwork (sellerId) {
      ChatworkService.createGroup({seller_id: sellerId})
        .then(response => {
        })
        .catch(err => {
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
    },
    toLogin () {
      this.$router.push('/login')
    },
    toSignup () {
      this.$router.push('/signup')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/signup/SignupSuccess.vue